import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import './index.css';
import App from './App';
import configureStore from './store/configureStore';
import './tracking.js';

global.__DEV__ = process.env.NODE_ENV === 'development';

const defaultState = {};
const store = configureStore(defaultState);

const render = Component => {
  ReactDOM.render(
    <AppContainer>
      <Component store={store} />
    </AppContainer>,
    document.getElementById('root')
  );
};

render(App);

if (module.hot) {
  module.hot.accept('./App', () => {
    render(App);
  });
}



// WEBPACK FOOTER //
// ./src/index.js